import {Component} from '@angular/core';
import {SubscriberComponent} from '../subscriber.component';
import {TimecardService} from '../../_services/timecard.service';

@Component({
    selector: 'bb-clock-in-out',
    templateUrl: './clock-in-out.component.html',
    styleUrls: ['./clock-in-out.component.scss'],
})
export class ClockInOutComponent extends SubscriberComponent {

    constructor(
        private timecardService: TimecardService
    ) {
        super();
    }

    async clockIn() {
        await this.timecardService.presentClockIn();
    }

    async clockOut() {
        await this.timecardService.presentClockOut();
    }
}
